import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function GradingActionsSection({ qir, onChange, businessUnitDetails }) {
    const { t } = useTranslation();

    function GetSuggestedGradingActionDropDownElements() {
        // If currently selected Qir option does not exist in the list then we should add it in to prevent unnecessary changes
        if (qir.suggestedGradingAction && !businessUnitDetails?.suggestedGradingActions?.includes(qir.suggestedGradingAction)) {
            return [qir.suggestedGradingAction, ...businessUnitDetails.suggestedGradingActions];
        }
        return businessUnitDetails?.suggestedGradingActions ?? [];
    }

    return (
        <Card className="mb-2">
            <Card.Header>{t('QIRDetail.Sections.GradingActionsSection')}</Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Group as={Row} className="mb-1" controlId="lotSplitRequired">
                            <Form.Label column sm={2}>
                                {t('QIRDetail.Fields.LotSplitRequired')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="lotSplitRequiredYes"
                                        label={t('Application.Controls.Yes')}
                                        name="lotSplitRequired"
                                        value="true"
                                        checked={qir.lotSplitRequired === true}
                                        onChange={onChange}
                                    />

                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="lotSplitRequiredNo"
                                        label={t('Application.Controls.No')}
                                        name="lotSplitRequired"
                                        value="false"
                                        checked={qir.lotSplitRequired === false}
                                        onChange={onChange}
                                    />
                                </Form>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Row} className="mb-1" controlId="qirSuggestedGradingActionId">
                            <Form.Label column sm={3}>{t('QIRDetail.Fields.SuggestedGradingAction')}</Form.Label>
                            <Col sm={9}>
                                <Form.Select value={qir.suggestedGradingAction ?? ""} size="sm" name="suggestedGradingAction" onChange={onChange}>
                                    <option key="" value="">{t('Application.Controls.DefaultSelect')}</option>
                                    {
                                        GetSuggestedGradingActionDropDownElements().map((action) => {
                                            return <option key={action} value={action}>{action}</option>;
                                        })
                                    }
                                </Form.Select>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {qir.lotSplitRequired === true &&
                            <Form.Group as={Row} className="mb-3" controlId="lotSplitStatement">
                                <Form.Label column sm={2}>{t('QIRDetail.Fields.LotSplitStatement')}</Form.Label>
                                <Col sm={10}>
                                    <Form.Control as="textarea" size="sm" rows={3} value={qir.lotSplitStatement ?? ""} name="lotSplitStatement" onChange={onChange} />
                                </Col>
                            </Form.Group>
                        }
                    </Col>
                    <Col>
                        {qir.suggestedGradingAction &&
                            <Form.Group as={Row} className="mb-3" controlId="suggestedGradingActionNotes">
                                <Form.Label column sm={3}>{t('QIRDetail.Fields.GradingActionNotes')}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control as="textarea" size="sm" rows={3} value={qir.gradingActionNotes ?? ""} name="gradingActionNotes" onChange={onChange} />
                                </Col>
                            </Form.Group>
                        }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default GradingActionsSection;